import { Box, Typography, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

const MyPatientsListToolbar = ({ onAddPatientClick }) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Box>
        <Typography
          sx={{ m: 1, fontSize: "1.45rem", color: "primary.dark" }}
          variant="h4"
        >
          Consulta de pacientes
        </Typography>
      </Box>
      <Box sx={{ m: 1 }}>
        {/* <Button
          sx={{ mr: 1, fontSize: "0.75rem", fontWeight: "400" }}
          color="primary"
          variant="contained"
          onClick={onAddPatientClick}
        >
          Alta de paciente
        </Button> */}

        <LoadingButton
          color="primary"
          size="large"
          type="button"
          variant="contained"
          onClick={onAddPatientClick}
        >
          Alta de paciente
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default MyPatientsListToolbar;
